import {
  PatientInternalNoteDialog,
  type InternalNoteRecord,
  type InternalNoteSaveResult,
} from "@/components/PatientInternalNoteDialog";
import type { InternalNoteV2 } from "../types";

type Props = {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  patientId: string;
  noteToEdit: InternalNoteV2 | null;
  authorName: string;
  canManageNote: (note: InternalNoteV2) => boolean;
  onSaved: (result: InternalNoteSaveResult) => void;
};

export function AddInternalNoteDialog({
  open,
  onOpenChange,
  patientId,
  noteToEdit,
  authorName,
  canManageNote,
  onSaved,
}: Props) {
  return (
    <PatientInternalNoteDialog
      open={open}
      onOpenChange={onOpenChange}
      patientId={patientId}
      noteToEdit={(noteToEdit as InternalNoteRecord | null) ?? null}
      authorName={authorName}
      canManageNote={(note) => canManageNote(note as InternalNoteV2)}
      onSaved={onSaved}
    />
  );
}
